export default interface IOnboardingDashboard {
    MonthlyGoal: number;
    CompletedMonthToDate: number;
    NeededToday: number;
    NeededForRestOfMonth: number | null;
    SchedulingConversionRate: number | null;
    SchedulingConversionYear: number | null;
    SchedulingConversionMonth: number | null;
    ScheduledToday: number;
    ConversionRateMonthToDate: number;
    UpcomingAppointmentsThisMonth: number;
    UpcomingAppointmentsNextMonth: number;
    RescheduledThisMonth: number;
    NeedsReschedule: number;
    CallsMadeToday: number;
    UndocumentedOnboards: number;  
}

export class OnboardingDashboard implements IOnboardingDashboard
{
    MonthlyGoal: number;
    CompletedMonthToDate: number;
    NeededToday: number;
    NeededForRestOfMonth: number | null;
    SchedulingConversionRate: number | null;
    SchedulingConversionYear: number | null;
    SchedulingConversionMonth: number | null;
    ScheduledToday: number;
    ConversionRateMonthToDate: number;
    UpcomingAppointmentsThisMonth: number;
    UpcomingAppointmentsNextMonth: number;
    RescheduledThisMonth: number;
    NeedsReschedule: number;
    CallsMadeToday: number;
    UndocumentedOnboards: number;

    constructor() {
        this.MonthlyGoal = 0;
        this.CompletedMonthToDate = 0;
        this.NeededToday = 0;
        this.NeededForRestOfMonth = 0;
        this.SchedulingConversionRate = null;
        this.SchedulingConversionYear = null;
        this.SchedulingConversionMonth = null;
        this.ScheduledToday = 0;
        this.ConversionRateMonthToDate = 0;
        this.UpcomingAppointmentsThisMonth = 0;
        this.UpcomingAppointmentsNextMonth = 0;
        this.RescheduledThisMonth = 0;
        this.NeedsReschedule = 0;
        this.CallsMadeToday = 0;
        this.UndocumentedOnboards = 0;
    }
}